import React, { useState } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { FileText, Download, Search, Calendar, ChevronDown } from 'lucide-react';

const FacultyManagementBoard2022 = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('all');

  const decisions = [
    { id: 1, number: 'FYKK/29.12.2022', date: '2022-12-29', title: 'Fakülte Yönetim Kurulu Kararları (29.12.2022)', description: '29 Aralık 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Aralık', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/29.12.2022%20FYKK.docx' },
    { id: 2, number: 'FYKK/21.12.2022', date: '2022-12-21', title: 'Fakülte Yönetim Kurulu Kararları (21.12.2022)', description: '21 Aralık 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Aralık', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/21.12.2022%20FYKK.docx' },
    { id: 3, number: 'FYKK/15.12.2022', date: '2022-12-15', title: 'Fakülte Yönetim Kurulu Kararları (15.12.2022)', description: '15 Aralık 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Aralık', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/15.12..2022%20FYKK.docx' },
    { id: 4, number: 'FYKK/08.12.2022', date: '2022-12-08', title: 'Fakülte Yönetim Kurulu Kararları (08.12.2022)', description: '8 Aralık 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Aralık', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/08.12.2022%20FYKK.docx' },
    { id: 5, number: 'FYKK/01.12.2022', date: '2022-12-01', title: 'Fakülte Yönetim Kurulu Kararları (01.12.2022)', description: '1 Aralık 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Aralık', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/01.12.2022%20fykk.docx' },
    { id: 6, number: 'FYKK/24.11.2022', date: '2022-11-24', title: 'Fakülte Yönetim Kurulu Kararları (24.11.2022)', description: '24 Kasım 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Kasım', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/24.11.2022%20FYKK.docx' },
    { id: 7, number: 'FYKK/17.11.2022', date: '2022-11-17', title: 'Fakülte Yönetim Kurulu Kararları (17.11.2022)', description: '17 Kasım 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Kasım', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/17.11.2022-1%20FYKK.docx' },
    { id: 8, number: 'FYKK/10.11.2022', date: '2022-11-10', title: 'Fakülte Yönetim Kurulu Kararları (10.11.2022)', description: '10 Kasım 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Kasım', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/10.11.2022%20FYKK.docx' },
    { id: 9, number: 'FYKK/03.11.2022', date: '2022-11-03', title: 'Fakülte Yönetim Kurulu Kararları (03.11.2022)', description: '3 Kasım 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Kasım', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/03.11.2022%20(1)%20FYKK.docx' },
    { id: 10, number: 'FYKK/20.10.2022', date: '2022-10-20', title: 'Fakülte Yönetim Kurulu Kararları (20.10.2022)', description: '20 Ekim 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Ekim', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/20.10.22%20FYKK%20(1).docx' },
    { id: 11, number: 'FYKK/13.10.2022', date: '2022-10-13', title: 'Fakülte Yönetim Kurulu Kararları (13.10.2022)', description: '13 Ekim 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Ekim', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/13.10.22%20FYKK.docx' },
    { id: 12, number: 'FYKK/12.10.2022', date: '2022-10-12', title: 'Fakülte Yönetim Kurulu Kararları (12.10.2022)', description: '12 Ekim 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Ekim', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/12.10.22%20FYKK.docx' },
    { id: 13, number: 'FYKK/06.10.2022', date: '2022-10-06', title: 'Fakülte Yönetim Kurulu Kararları (06.10.2022)', description: '6 Ekim 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Ekim', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/06.10.22%20FYKK.docx' },
    { id: 14, number: 'FYKK/28.09.2022', date: '2022-09-28', title: 'Fakülte Yönetim Kurulu Kararları (28.09.2022)', description: '28 Eylül 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Eylül', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/28.09.2022%20FYKK.docx' },
    { id: 15, number: 'FYKK/26.09.2022', date: '2022-09-26', title: 'Fakülte Yönetim Kurulu Kararları (26.09.2022)', description: '26 Eylül 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Eylül', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/26.09.2022-1%20Fak%C3%BClte%20YKK.docx' },
    { id: 16, number: 'FYKK/14.09.2022', date: '2022-09-14', title: 'Fakülte Yönetim Kurulu Kararları (14.09.2022)', description: '14 Eylül 2022 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.', month: 'Eylül', fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/FYKK/FYKK%20(14.09.2022).docx' }
  ];

  const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 
                  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  const filteredDecisions = decisions.filter(decision => {
    const matchesSearch = decision.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         decision.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         decision.number.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesMonth = selectedMonth === 'all' || decision.month === selectedMonth;
    return matchesSearch && matchesMonth;
  });

  return (
    <PageTemplate 
      title="2022 Yılı Fakülte Yönetim Kurulu Kararları"
      breadcrumb={[
        { label: 'Anasayfa', url: '/' },
        { label: 'Fakülte Kararları', url: '/kararlar' },
        { label: 'Fakülte Yönetim Kurulu Kararları', url: '/kararlar/fakulte-yonetim' },
        { label: '2022' }
      ]}
    >
      <div className="max-w-6xl mx-auto">
        {/* Başlık */}
        <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-xl p-8 mb-8">
          <div className="flex items-center mb-4">
            <FileText className="w-8 h-8 text-green-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-800">2022 Yılı Fakülte Yönetim Kurulu Kararları</h2>
          </div>
          <p className="text-gray-700">
            2022 yılında alınan toplam {decisions.length} adet fakülte yönetim kurulu kararını inceleyebilirsiniz.
          </p>
        </div>

        {/* Filtreler */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Arama */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Karar ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
              />
            </div>

            {/* Ay Filtresi */}
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all appearance-none bg-white"
              >
                <option value="all">Tüm Aylar</option>
                {months.map(month => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
              <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Kararlar Listesi */}
        <div className="space-y-6">
          {filteredDecisions.map((decision) => (
            <div 
              key={decision.id}
              className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow p-6"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-3">
                    <span className="bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
                      Karar No: {decision.number}
                    </span>
                    <span className="text-gray-500 text-sm">{decision.date}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {decision.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {decision.description}
                  </p>
                </div>
                <div className="ml-6">
                  <a 
                    href={decision.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors"
                  >
                    <Download className="w-4 h-4" />
                    <span>İndir</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sonuç bulunamadı */}
        {filteredDecisions.length === 0 && (
          <div className="text-center py-12">
            <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Karar bulunamadı</h3>
            <p className="text-gray-500">
              Arama kriterlerinize uygun karar bulunmamaktadır. Lütfen farklı terimler deneyin.
            </p>
          </div>
        )}
      </div>
    </PageTemplate>
  );
};

export default FacultyManagementBoard2022; 